import React, { FC } from 'react';
import { Asset } from '../../../api';
import '../styles.scss';
import { useSelector, useDispatch } from 'react-redux';
import { getAssetsInFavorite, getInProgress, getAllInProgress } from '../selectors';
import * as favoriteActions from '../actions';
import { Button } from '@myua/kit';
import { getAssetLabLogger } from '../../app/logs';
import { Star } from '@myua/icons/dist/bulk24';
import { Star1 } from '@myua/icons/dist/linear24';
import { getPermissions } from '../../app/selectors';
import { Permission } from '../../../../general/model';

export const FavoriteToggle: FC<{ asset: Asset }> = ({ asset }) => {
  const dispatch = useDispatch();
  const checked = Boolean(useSelector(getAssetsInFavorite)[asset.id]);
  const allInProgress = useSelector(getAllInProgress);
  const inProgress = useSelector(getInProgress);
  const assetLabLogger = useSelector(getAssetLabLogger);

  const permissions = useSelector(getPermissions);
  if (!permissions[Permission['fs.assetlab_favorites']]) {
    return null;
  }

  // Если данный ассет уже в обработке или если все ассеты в обработке, то не позволяем нажимать кнопку.
  const disabled = allInProgress || inProgress[asset.id];

  return (
    <Button
      type="text"
      shape="circle"
      size="small"
      disabled={disabled}
      title={checked ? 'Delete from favorites' : 'Add to favorites'}
      className={`al-favorite-toggle ${checked ? 'al-favorite-toggle_checked' : ''}`}
      icon={checked ? <Star /> : <Star1 />}
      onClick={() => {
        const add = !checked;
        const assets = [asset];
        dispatch(favoriteActions.assetsToggled({ add, assets }));
        assetLabLogger({
          action: 'Favorite',
          sub_action: 'Toggle',
          extra: {
            // asset_ids: assets.map(({ id }) => id),
            bool_1: add,
            text_1: 'single',
          },
        });
      }}
    />
  );
};

export const FavoriteToggleMultiple: FC<{ assets: Asset[] }> = ({ assets }) => {
  const dispatch = useDispatch();
  const assetLabLogger = useSelector(getAssetLabLogger);
  const inProgress = useSelector(getInProgress);
  const allInProgress = useSelector(getAllInProgress);
  const assetsInFavorite = useSelector(getAssetsInFavorite);

  const permissions = useSelector(getPermissions);
  if (!permissions[Permission['fs.assetlab_favorites']]) {
    return null;
  }

  // Если хотя бы один ассет уже в обработке, то не позволяем нажимать кнопку.
  // Блокируем ее, а не ставим loading, чтобы спиннер не смущал юзера, т.к. не все выбранные
  // ассеты могут находиться в обработке.
  const disabled = allInProgress || assets.some(({ id }) => inProgress[id]);

  const selectAll = assets.length === 0;

  const checked = selectAll
    ? // Если находимся в режиме обработки сразу всех ассетов, то мы не знаем, все ли они уже в избранном или нет,
      // поэтому предлагаем добавить их в избранное.
      false
    : // Если хотя бы один из выбранных ассетов не добавлен, то предлагаем добавить
      // все выбранные ассеты. Иначе предлагаем удалить все выбранные ассеты.
      assets.every(({ id }) => assetsInFavorite[id]);

  return (
    <Button
      disabled={disabled}
      onClick={() => {
        const add = !checked;
        dispatch(favoriteActions.assetsToggled({ add, assets, selectAll }));
        assetLabLogger({
          action: 'Favorite',
          sub_action: 'Toggle',
          extra: {
            // asset_ids: assets.map(({ id }) => id),
            bool_1: add,
            text_1: selectAll ? 'all' : 'multiple',
          },
        });
      }}
    >
      {checked ? 'Remove from favorites' : 'Add to favorites'}
    </Button>
  );
};
